import React from 'react';
import {FormattedMessage} from "react-intl";
import TableCell from "@amzn/meridian/table/table-cell";

const SORT_COL_TO_FORMATTED_ID_MAP = {
    currentStowBufferedPackages: "common.stow_buffered",
    currentMFRJackpotBufferedPackages: "common.jackpot_buffered_mfr"
}

const SORT_COL_TO_FORMATTED_DEFAULT_MSG_MAP = {
    currentStowBufferedPackages: "Stow buffered",
    currentMFRJackpotBufferedPackages: "Jackpot buffered (MFR)"
}

export const getTableCellHeader = (sortColumn) => {
    return <TableCell sortColumn={sortColumn} alignmentHorizontal="right">
        <FormattedMessage id={SORT_COL_TO_FORMATTED_ID_MAP[sortColumn]}
                          defaultMessage={SORT_COL_TO_FORMATTED_DEFAULT_MSG_MAP[sortColumn]}/>
    </TableCell>
}

export const getTableCellCount = (count) => {
    return (
        <TableCell alignmentHorizontal="right">{count}</TableCell>
    )
}



// WEBPACK FOOTER //
// ./src/components/utils/TableCellUtil.js